import {Container, SmallView, Text1, Title1, View} from "../../../../styles/business-components";
import * as S from './styles'

import Image from '../../../../assets/images/business/b_m_cnt1_img1.png'

export const Content1 = () => {
    return (
        <Container>
            <View>
                <S.Content>
                    <div>
                        <S.Image src={Image}/>
                    </div>
                    <div>
                        <Title1>
                            Безопасно общайтесь и работайте в команде
                        </Title1>
                        <Text1>Простое и безопасное решение для совещаний, чатов и обмена данными.</Text1>
                        <Text1>До 100 участников из любой точки мира могут одновременно участвовать в конференции.</Text1>
                    </div>
                </S.Content>
            </View>
            <SmallView>
                <Title1>
                    Безопасно общайтесь и работайте в команде
                </Title1>
                <S.SmallContent>
                    <div>
                        <S.Image src={Image}/>
                    </div>
                    <div>
                        <Text1>Простое и безопасное решение для совещаний, чатов и обмена данными.</Text1>
                        <Text1>До 100 участников из любой точки мира могут одновременно участвовать в конференции.</Text1>
                    </div>
                </S.SmallContent>
            </SmallView>
        </Container>
    )
}